export default __webpack_public_path__ + "static/media/dropdown.a6a2a1ec.svg";